module.exports = __webpack_public_path__ + "static/media/lots-icon.9d6d67f7.svg";